import React from "react";
import { useField } from "formik";
import { Input } from "reactstrap";
import PropTypes from "prop-types";

const propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  isDisabled: PropTypes.string,
  labelProps: PropTypes.shape({
    className: PropTypes.string.isRequired
  }).isRequired
};

const defaultProps = {
  isDisabled: "false"
};

function TextInput({ label, labelProps, isDisabled, ...props }) {
  // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
  // which we can spread on <input> and also replace ErrorMessage entirely.
  const [field, meta] = useField(props);
  return (
    <>
      {label && (
        <label
          htmlFor={props.id || props.name}
          className={labelProps.className}
        >
          {label}
        </label>
      )}
      <Input
        disabled={isDisabled === "true"}
        {...field}
        {...props}
        className={meta.touched && meta.error ? "form-error" : ""}
      />
      {meta.touched && meta.error ? (
        <div className="error">{meta.error}</div>
      ) : null}
    </>
  );
}

TextInput.propTypes = propTypes;
TextInput.defaultProps = defaultProps;

export default TextInput;
